import React, {useEffect, useState} from 'react'
import {
  ModalBody, ModalFooter,
  Button,
  Form,
  FormGroup, Label, Input
} from 'reactstrap'

import Lang from 'Lang/General'

function PassForm({
  onSubmit,
  ... props
}) {
  const [tempFirstName, setTempFirst] = useState('')
  const [tempLastName, setTempLast] = useState('')

  useEffect(() => {
    if(props.selectedToEdit){
      setTempFirst(props.selectedToEdit.first_name)
      setTempLast(props.selectedToEdit.last_name)
    }
  }, [props.selectedToEdi])

  return (
    <>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>
              {Lang['FIRST_NAME'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={tempFirstName}
              onChange={e => setTempFirst(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['LAST_NAME'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={tempLastName}
              onChange={e => setTempLast(e.target.value)}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color={'primary'}
          onClick={() => onSubmit({
            ... props.selectedToEdit,
            first_name: tempFirstName,
            last_name: tempLastName
          })}
        >
          {Lang['SUBMIT'][props.data.languageReducer.userSettings.admin_panel_language]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default PassForm